module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("FOUR FACTORS AFFECT REAL ESTATE INVESTING")])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "chap-tit"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("These Issues Influence Your Interests")])])])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Like every other type of investing, real estate investing is affected by a variety of factors. Some of these have a direct and obvious effect; for example, rising interest rates lead to lower property values. Others, such as changing demographics, have a less focused impact that affects values over time.")]), _vm._v(" "), _c('p', {
    staticClass: "box-head"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Normal Cycle")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("The economy has a normal cycle, rising and falling in a predictable order (though not at predictable times). Every cycle has four phases: expansion, peak, contraction, and trough. If you know which stage the economy is in, you’ll know what’s coming next and be able to manage your investments appropriately.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These factors matter most when you’re buying and selling real estate investments, less when you’re holding on to existing investments. The main exceptions: trading-based investments like real estate–related stocks (such as construction companies) or real estate mutual funds and ETFs (exchange-traded funds), because they’re also subject to stock market forces in addition to the factors that affect real estate.")])]), _c('h4', {
    staticClass: "h4a"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("THE ECONOMY")])])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The overall state of the economy can have an enormous impact on real estate investing, but the type of effect depends on the type of investment. In general, real estate values will flourish in a robust economy and shrink in a sluggish economy. Real estate investments, though, can thrive in any kind of economy, and some do even better when the economy is down.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("How a Slow Economy Affects Real Estate Investments")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Different sectors within the real estate investment world aren’t impacted the same way by changes in the economy. Some types of investment real estate are greatly affected during an economic slowdown; therefore REITs and funds specializing in these areas could see big price drops. Well-managed funds could snap up distressed commercial properties for a song, holding them in anticipation of the inevitable economic resurgence. Specific types of real estate that tend to buckle in a slow economy include:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Hotels")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• New home construction")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• Shopping centers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other types of real estate investments thrive in a down economy. For example, discount retailers see an uptick in sales as people adjust their budgets. Sin industries, which include casinos, also flourish as the economy worsens. Other recession-resistant property types are self-storage facilities and mobile home parks.")])]), _c('h4', {
    staticClass: "h4a"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INTEREST RATES")])])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Interest rates may be the biggest driver of the real estate market, because they directly impact the ability to buy property. That’s especially true in the residential real estate market, important to landlords and house flippers: when rates are low, it costs less to take on a mortgage so people are more likely to buy, and that increased demand can drive up real estate prices. When rates begin to rise, mortgage costs go up, and that makes prospective homeowners less likely to buy, which can eventually lower real estate prices. That can be a double bonus for landlords, because any extra mortgage costs can be passed right through to tenants in the form of higher rent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rates also affect other types of real estate investments. REITs (real estate investment trusts), for example, offer a steady yield (sort of like interest on a bond). When interest rates drop, it makes those yields look better, so demand for REITs increases and their prices increase too. On the flip side, when interest rates rise, they can outpace that yield, making REITs look less attractive and lowering their market value. Those price fluctuations matter more if you’re buying or selling—not if you’re just sitting back and collecting the income from your REIT investments.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("DEMOGRAPHICS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("When it comes to real estate, people matter, and that’s what demographics are all about. Essentially, demographics are statistics about the population and its subgroups that help describe group behaviors. Demographic factors include things like:")])]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("• Age")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• Income level")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Marital status")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Occupation")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• Family size")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Real estate investors use demographic data to make decisions about things such as which types of properties to buy, which geographical areas to focus on, and how to make proactive investment choices based on upcoming population trends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Big shifts in demographics can impact real estate trends for years, especially when it comes to residential rental properties. For example, as baby boomers move toward retirement, they could spark big changes in the real estate market. Baby boomers own about 40 percent of homes in the US; that could lead to a sell-off of larger family homes as they downsize to maintenance-friendly condo-style properties, increasing the number of single-family homes for sale. More homes on the market could lead to a sharp decline in home prices—bad for homeowners but a benefit for real estate investors looking to snap up residential properties.")]), _vm._v(" "), _c('p', {
    staticClass: "box-head"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Southbound")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("According to ATTOM Data, 62 percent of the growth in the real estate market will be heading south. Thanks to warmer weather, more affordable housing, and job availability, they predict more people will be moving to states like Texas, Georgia, and Arizona.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Other boomer-related trends could include shifts away from colder climates to more temperate areas, an increased demand for independent living communities, and a swing toward more convenient urban-style areas—all important factors for real estate investors to consider.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h4', {
    staticClass: "h4a"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("GOVERNMENT ACTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Federal, state, and local governments can have a measurable impact on both demand for real estate and property values. They can boost demand in an area by offering tax deductions, tax credits, and subsidies to drive investor interest. They can steer policy and legislation for specific effect, like the introduction of the first-time homebuyer credit in 2009, which encouraged home sales in a sagging real estate market.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("SALT Tax Deduction")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 2017 Tax Cuts and Jobs Act (TCJA) capped the total tax deduction for state and local taxes (SALT) to $10,000; that includes state and local income taxes and property taxes. The new cap could have a chilling effect on new homeownership, but it could also greatly benefit direct and indirect residential rental property owners. Plus, the SALT cap doesn’t affect real estate investors, who can still deduct the full amount of taxes paid to support rental properties.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Opportunity Zones")])])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The TCJA also created tax-advantaged Opportunity Zones to attract long-term investment in distressed areas and spur development and job creation. There are designated OZs in every state and ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("five US territories. Investments must be made through Qualified Opportunity Funds (QOFs), which are basically holding companies set up to allow investment in eligible properties. Potential tax benefits include:")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_vm._v("• Defer tax on "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("prior gains")]), _vm._v(" until 2026. That means if someone sells stock and makes a $100,000 profit, then puts that money in a QOF, they don’t have to pay taxes on the profit now.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Exclude 10 percent of that prior gain "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("forever")]), _vm._v(" if they hold the OZ property for at least five years, and 15 percent if they hold it for seven years.")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• Investors who hold QOF investments for at least ten years won’t have to pay any capital gains tax on profits when they sell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you might imagine, OZs have real estate investors across the US very excited—but the rules are brand-new, and no one has actually tested them out yet. Proceed with caution.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("You can learn more about Opportunity Zones on the IRS website (")]), _c('a', {
    attrs: {
      "href": "http://www.irs.gov",
      "target": "_blank"
    }
  }, [_vm._v("www.irs.gov")]), _vm._v(").")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-889bdd70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01_sub03.vue
// module id = 78
// module chunks = 0